import React from 'react';
import PropTypes from 'prop-types';
import locale from '@glu/locale';
import { PersonNextIcon } from '@glu/icons-react';
import IconLink from './IconLink';
import useStyles from './UserLink.styles';

const UserLink = (props) => {
  const {
    lastLogin,
    name,
    UserIcon
  } = props;
  const classes = useStyles(props);
  return (
    <IconLink Icon={UserIcon} className={classes.userLink}>
      <div className={classes.container}>
        {name}
        {lastLogin && (
          <p className={classes.subText}>
            <strong>
              {`${locale.get('nav.lastLogin')}:`}
            </strong>
            {' '}
            {lastLogin}
          </p>
        )}

      </div>
    </IconLink>
  );
};

UserLink.propTypes = {
  /** Last login time to show under the user name */
  lastLogin: PropTypes.string,
  /** User name to show */
  name: PropTypes.string.isRequired,

  UserIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
};

UserLink.defaultProps = {
  UserIcon: PersonNextIcon,
  lastLogin: undefined
};

export default UserLink;
